module.exports = __webpack_public_path__ + "static/img/1-1.da759cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/1-1.png
// module id = 7xp4
// module chunks = 0